var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgYoutubeIcon = function SvgYoutubeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.94 6.6c1.204.331 2.153 1.306 2.475 2.543.585 2.242.585 6.92.585 6.92s0 4.677-.585 6.92c-.322 1.236-1.271 2.21-2.476 2.541-2.183.601-10.939.601-10.939.601s-8.756 0-10.94-.6c-1.204-.331-2.153-1.305-2.475-2.543C2 20.74 2 16.062 2 16.062s0-4.677.585-6.92c.322-1.236 1.27-2.21 2.476-2.541C7.244 6 16 6 16 6s8.756 0 10.94.6Zm-13.565 5.526v8.75l7-4.375-7-4.376Z",
    fill: "#fff"
  })));
};
export default SvgYoutubeIcon;